import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { SearchResult } from "../models/search-result.model";
import { ApptResourceLoadModel } from "../models/appt-resource-str.model";
import { AppointmentModel } from "../models/appt-resource-str.model";
import { SelectedPetForApptModel } from "../models/appt-resource-str.model";
import { PetPatientModel } from "../models/pet-patient.model";
import { PetModel } from "../models/pet.model";
import { CompleteApptModel } from "../models/appt-complete.model";
import { CompleteApptSubModel } from "../models/appt-complete.model"; 
import { ApptCodeTotalModel } from "../models/appt-total.model"; 
import { FutureApptsModel } from "../models/appt.model"; 
import { SampleEmployeeModel } from "../models/sample.model"; 
import { tblApptResourceModel } from "../models/appt-resource.model";
import { ApptProcTotalModel } from "../models/appt-proc-total.model";
import { Subject } from 'rxjs';



@Injectable({
    providedIn: "root"
})
export class AppointmentService {

    private baseUrl: string = 'appt'; 
    // userData: any = JSON.parse(localStorage['currentUser']);
    // clinicData: any = (JSON.parse(localStorage['clinic'])).find(x => x.clinic_no == this.userData.clinic_no);
    appt_resources: ApptResourceLoadModel[] = []
    appt_resource: ApptResourceLoadModel = new ApptResourceLoadModel(0,'','','');
    appointments: AppointmentModel[] = [] 
    selected_pet_for_Appt: SelectedPetForApptModel[] = [] 
    selected_appt_resource = []
    pet_patient: PetPatientModel[] = [];
    pet_patientsingle: PetPatientModel = new PetPatientModel('', '', '','','','','','','','','','','');
    pet: PetModel = new PetModel(0, 0, '', '', 0, '', '', '', '', '', 0, 0, '', '', '', '', '', 0, 0, 0, '', false, 0, '', '', '', '',0, 0, '', 0, '', false);
    pets: PetModel[] = [];
    complete_appt_model: CompleteApptModel = new CompleteApptModel(0,0,'','',0,'','',0,'',false,'','','','',false,0)
    complete_apptsub_model: CompleteApptSubModel[] = [];
    apptcode_totalmodel: ApptCodeTotalModel[] = [];
    future_apptsmodel: FutureApptsModel[] = [];
    apptproctotal_model: ApptProcTotalModel[] = [];
    //apptsubsolo_model: CompleteApptSubModel = new CompleteApptSubModel(0, 0, appointment_date: string, pet_no: number, pet_name: string, appt_proc_id: number, dtime: number, code1: string, code2: string, code3: string)

    tbl_appt_resources: tblApptResourceModel[] = [];
    pickupDate: string;
    pickupTime: string;
    selectedItems1: any[] = new Array(this.selected_pet_for_Appt.length) 
    selectedItems2: any[] = new Array(this.selected_pet_for_Appt.length) 

    appts_petsclients: AppointmentModel[] = [] 
    sampleemployee: SampleEmployeeModel[] = [] 

    
    tempMode:string = 'ADD'
    txtDocNameDisplay = true

    apptslist_search:{client_no:number, pet_no:number, datebegin:string, dateend:string} = {client_no:0, pet_no:0, datebegin:'', dateend:''}



    
    
    constructor(
        private api: ApiService
    ) { 
    }

    
    //for connecting a function on apptdetails
    apptdet_modalMode: string = 'VIEW';
    private notifyApptDetails = new Subject<void>();
    notifyApptDetailsObservable = this.notifyApptDetails.asObservable(); 
    notifyApptDetailsFunction() { 
        this.notifyApptDetails.next();
    }

    private notifyWorkApptDetails = new Subject<void>();
    notifyWorkApptDetailsObservable = this.notifyWorkApptDetails.asObservable(); 
    notifyWorkApptDetailsFunction() { 
        this.notifyWorkApptDetails.next();
    }

    private notifyWorkAppt = new Subject<void>();
    notifyWorkApptObservable = this.notifyWorkAppt.asObservable(); 
    notifyWorkApptFunction() {  
        this.notifyWorkAppt.next();
    }

    // Open Existing Schedule modal notification with prefilled date
    private openExistingSchedSubject = new Subject<string>();
    openExistingSchedObservable = this.openExistingSchedSubject.asObservable();
    openExistingSchedModal(date: string) {
        this.openExistingSchedSubject.next(date);
    }

    private notifyTagBoard = new Subject<void>();
    notifyTagBoardObservable = this.notifyTagBoard.asObservable(); 
    notifyTagBoardFunction() { 
        this.notifyTagBoard.next();
    }

    private notifyClientLookup = new Subject<string>();
    notifyClientLookupObservable = this.notifyClientLookup.asObservable(); 
    notifyClientLookupFunction(source: string) { 
        this.notifyClientLookup.next(source);
    }

    get userData(): any {
        return JSON.parse(localStorage.getItem('currentUser') || '{}');
    }
    
    get clinicData(): any {
        return (JSON.parse(localStorage['clinic'])).find(x => x.clinic_no == this.userData.clinic_no);
    }

    GetApptSec_ApptResource(appt_resource_date:string, clinic_no:number) {
        //let clinic_no = JSON.parse(localStorage['currentUser']).clinic_no;
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetApptSec_ApptResource?appt_resource_date=${appt_resource_date}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) {
                        this.appt_resources = res.data.map((element) => {
                            return new ApptResourceLoadModel(element.appt_resource_id,element.appt_resource_code,element.appt_resource_time_str,element.appt_resource_category);
                        });

                        resolve(1);
                    } else {
                        this.appt_resources = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetApptSec_Appts(appt_resource_date:string, clinic_no:number) {
        //let clinic_no = this.userData.clinic_no;
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetApptSec_Appts?appt_resource_date=${appt_resource_date}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) {
                        this.appointments = res.data.map((element) => {
                            return new AppointmentModel(element.appointment_id, element.dropoff_time_needed, element.doctor_time_needed, 
                                element.client_no,element.appointment_date, element.last_name, element.first_name, element.doctor, element.dropoff_time, 
                                element.dropoff, element.pet_no, element.pet_name,element.breed,element.color,element.appt_proc_id, element.appt_proc_name, element.appointment_note, element.code1, 
                                element.code2, element.code3, element.code4, element.appt_fulfill,element.status,element.tag_no,element.unscheduled);
                        });
                        resolve(1);
                    } else {
                        this.appointments = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    } 


    getPetsByClient(client_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`pet/getPetsByClient?client_no=${client_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pets = res.data.map((element) => {
                            if(element.active === 'Y' && element.deceased === false){
                                return new PetModel(element.pet_no, client_no, '', element.pet_name, element.weight, element.sex, element.dob, element.neuter, element.rabieDate, element.active, element.temperature, element.height, element.pet_code, element.picture, element.breed_name, element.color_name, element.specie_name, element.breed, element.color, element.specie, element.tag_no, false, element.age, element.blood_pressure, element.rabies, element.chip_no, element.assigned_doctor,element.body_score,element.alt_breed,element.alt_breed_name,element.alt_color,element.alt_color_name, element.deceased);
                            } 
                            else{
                                return null;
                            }
                            //return new PetModel(element.pet_no, client_no, '', element.pet_name, element.weight, element.sex, element.dob, element.neuter, element.rabieDate, element.active, element.temperature, element.height, element.pet_code, element.picture, element.breed_name, element.color_name, element.specie_name, element.breed, element.color, element.specie, element.tag_no, false, element.age, element.blood_pressure, element.rabies, element.chip_no, element.assigned_doctor,element.body_score,element.alt_breed,element.alt_breed_name,element.alt_color,element.alt_color_name, element.deceased);
                        }).filter(pet => pet !== null);
                        resolve(1);
                    } else {
                        this.pets = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetApptByApptID(appointment_id: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetApptByApptID?appointment_id=${appointment_id}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.complete_appt_model = new CompleteApptModel(res.data[0].appointment_id,res.data[0].client_no,res.data[0].appointment_date,res.data[0].dropoff_time,res.data[0].dropoff_time_needed,res.data[0].pickup_time,res.data[0].doctor,res.data[0].doctor_time_needed,res.data[0].appointment_note,res.data[0].dropoff,res.data[0].made_by,res.data[0].modified_by,res.data[0].create_date,res.data[0].appt_fulfill,res.data[0].unscheduled,res.data[0].clinic_no)                        

                        resolve(1);
                    } else {
                        this.complete_appt_model = new CompleteApptModel(0,0,'','',0,'','',0,'',false,'','','','',false,0)
                        resolve(0);
                    }
                });
        });
        return promise;
    }
    
    GetApptSubByApptID(appointment_id: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetApptSubByApptID?appointment_id=${appointment_id}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.complete_apptsub_model = res.data.map((element) => {
                            return new CompleteApptSubModel(
                                element.sub_appt_id,
                                element.appointment_id,
                                element.appointment_date,
                                element.pet_no,
                                element.pet_name,
                                element.appt_proc_id,
                                Number(element.dtime) || 0,
                                element.code1,
                                element.code2,
                                element.code3,
                                element.code4,
                                element.status
                            );
                        });
                        resolve(1);
                    } else {
                        this.complete_apptsub_model = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetMaxAppointmentId() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetMaxAppointmentId`)
                .subscribe((res: any) => {
                    if (res && res.data) { 
                        resolve(res.data);
                    } else { 
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    SetupAppt(){   
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupAppt`, this.complete_appt_model)
                .subscribe((res: any) => { 
                    if (res && res.data) {
                        resolve(res.data);
                    } else {
                        resolve(0);
                    }
                }); 
        });
        return promise;
    }  

    SetupApptSub(index){   
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupApptSub`, this.complete_apptsub_model[index])
                .subscribe((res: any) => { 
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                }); 
        });
        return promise;
    }  

    DeleteAppt(appointment_id:number){   
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/DeleteAppt?appointment_id=${appointment_id}`)
                .subscribe((res: any) => {  
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                }); 
        });
        return promise;
    } 
  
    getTotalApptCodeByMonth(dteBeginDate:string,dteEndDate:string,clinic_no:number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getTotalApptCodeByMonth?dteBeginDate=${dteBeginDate}&dteEndDate=${dteEndDate}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {  
                        this.apptcode_totalmodel = res.data.map((element) => {
                            return new ApptCodeTotalModel(element.appt_proc_id,element.appointment_date, element.appt_total);
                        });
                        resolve(1);
                    } else {
                        this.apptcode_totalmodel = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }
  
    GetLastApptByPetNo(pet_no:number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetLastApptByPetNo?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) { 
                        resolve(res.data);
                    } else { 
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetFutureAppts(client_no:number,today:boolean) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetFutureAppts?client_no=${client_no}&today=${today}`)
                .subscribe((res: any) => {
                    if (res && res.data) { 
                        this.future_apptsmodel = res.data.map((element) => {
                            return new FutureApptsModel(element.appointment_date,element.dropoff_time, element.pet_name, element.appointment_id, element.appt_proc_name);
                        });
                        resolve(1);
                    } else { 
                        resolve(0);
                    }
                });
        });
        return promise;
    }  

    GetAppts_byPetNoClientNo(pet_no:number, client_no:number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetAppts_byPetNoClientNo?pet_no=${pet_no}&client_no=${client_no}`)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) {
                        this.appts_petsclients = res.data.map((element) => {
                            return new AppointmentModel(element.appointment_id, element.dropoff_time_needed, element.doctor_time_needed, 
                                element.client_no, element.appointment_date, element.last_name, element.first_name, element.doctor, element.dropoff_time, 
                                element.dropoff, element.pet_no, element.pet_name,element.breed,element.color,element.appt_proc_id, element.appt_proc_name, element.appointment_note, element.code1, 
                                element.code2, element.code3, element.code4, element.appt_fulfill,element.status,element.tag_no,element.unscheduled);
                        });
                        resolve(1);
                    } else {
                        this.appts_petsclients = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    } 

    GetApptResourceByDate(appt_resource_date:string, clinic_no: number)
    {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetApptResourceByDate?appt_resource_date=${appt_resource_date}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.tbl_appt_resources = res.data.map((element) => {
                            return new tblApptResourceModel(element.appt_resource_id,element.appt_resource_code,element.appt_resource_category,element.appt_resource_date,element.appt_resource_time_str,element.appt_doctor_load,element.clinic_no);
                        });
                        resolve(1);
                    } else {
                        this.tbl_appt_resources = [];
                        resolve(0);
                    }   
                });
        });
        return promise;
    } 

    UpdateApptResourceTime(appt_resource_id: number, appt_resource_time_str: string) {
        const encoded = encodeURIComponent(appt_resource_time_str || '');
        let promise = new Promise((resolve) => {
            this.api.post(`${this.baseUrl}/UpdateApptResourceTime?appt_resource_id=${appt_resource_id}&appt_resource_time_str=${encoded}`)
                .subscribe(
                    (res: any) => {
                        resolve(res && res.data ? 1 : 0);
                    },
                    () => resolve(0)
                );
        });
        return promise;
    }

    UpdateApptSubStatus(sub_appt_id: number, status: string)
    {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/UpdateApptSubStatus?sub_appt_id=${sub_appt_id}&status=${status}`)
                .subscribe((res: any) => {
                    resolve(res && res.data ? 1 : 0);
                });
        });
        return promise;
    }

    GetApptProcTotal(date: string, clinic_no: number){
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetApptProcTotal?date=${date}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.apptproctotal_model = res.data.map((element) => {
                            return new ApptProcTotalModel(element.appt_proc_id, element.appt_proc_name, element.appt_proc_code, element.appt_max, element.total_count, element.total_duration);
                        });
                        resolve(1);
                    } else {
                        this.apptproctotal_model = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    //#region functions for datetime formatting
    getCurrentDate(){
        const currentDate = new Date();

        const year = currentDate.getFullYear();
        const month = ('0' + (currentDate.getMonth() + 1)).slice(-2); // Month is 0-indexed
        const day = ('0' + currentDate.getDate()).slice(-2); 

        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    }

    getTime(datetimestr){
        const datetimeString = datetimestr;
        const datetime = new Date(datetimeString);
        const time = datetime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    
        return time
    }
    
    getTime_Military(datetimestr){  
    const date = new Date(datetimestr);
    const options: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hour12: false };
    const formattedTime = date.toLocaleTimeString('en-US', options);

    return formattedTime
    }
    
    getFormattedDate(datetimestr){
        const date = datetimestr
        const date_datePart = date.split(" ")[0]; // Extract the date portion
        const parts = date_datePart.split("/"); // Split date into parts [MM, DD, YYYY]
        const CombinedParts = `${parts[2]}-${parts[0]}-${parts[1]}`; // Format as YYYY-MM-DD
        return(CombinedParts);
    }
    
    formatTime(dateTime: string): string {
    const date = new Date(dateTime);
    const hours = date.getHours();
    const minutes = date.getMinutes();

    // Convert hours to 12-hour format with AM/PM
    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = (hours % 12) || 12;

    // Format the time as "hh:mm AM/PM"
    const formattedTime = `${formattedHours}:${minutes.toString().padStart(2, '0')} ${period}`;

    return formattedTime;
    
    }
    //#endregion functions for datetime formatting 




    
}